import {
  BadgeEuro,
  Briefcase,
  Car,
  Droplets,
  Flame,
  Frame,
  Gavel,
  Hammer,
  HeartPulse,
  Laptop,
  LifeBuoy,
  Lock,
  Luggage,
  type LucideIcon,
  Mountain,
  PawPrint,
  Radiation,
  Scale,
  Shield,
  ShieldCheck,
  Siren,
  Stethoscope,
  Wind,
  Wrench,
  Zap,
} from 'lucide-react';

// Peril ids are free-form per product (kebab, SCREAMING_SNAKE, English or French), so they are
// matched by concept keyword rather than enumerated; unmatched perils fall back to a shield.
const PERIL_ICONS: ReadonlyArray<readonly [RegExp, LucideIcon]> = [
  [/assistance|remorquage|depannage|towing|breakdown|rapatriement/, LifeBuoy],
  [/equipement|equipment|materiel/, Briefcase],
  [/bagage|luggage/, Luggage],
  [/bris|glass|vitrage/, Frame],
  [/incendie|fire|explosion/, Flame],
  [/(^|-)vol(-|$)|theft|vandal/, Lock],
  [/eau|water|degat/, Droplets],
  [/climatique|climatic|weather|tempete|storm|wind/, Wind],
  [/technologique|technological/, Radiation],
  [/catastrophe|natural-disaster/, Mountain],
  [/attentat|terrorist|attack|emeute|riot|protest/, Siren],
  [/penal|criminal|gavel/, Gavel],
  [/juridique|legal|defense|recours|avocat|lawyer|(^|-)pj(-|$)/, Scale],
  [/responsabilite|liability|indemnity|(^|-)rc(-|$)/, ShieldCheck],
  [/conducteur|driver/, HeartPulse],
  [/reparation|replacement-vehicle|vehicule-de-remplacement|garage|panne/, Wrench],
  [/amenagement|modification|transformation/, Hammer],
  [
    /valeur-a-neuf|replacement-value|new-value|indemnisation|compensation|franchise|plafond/,
    BadgeEuro,
  ],
  [/electr/, Zap],
  [/cyber|informatique/, Laptop],
  [/veterinaire|animal|(^|-)pet(-|$)/, PawPrint],
  [/sante|health|medical|hospital|chirurgie/, Stethoscope],
  [/accident|dommage|damage|collision|vehicule|vehicle/, Car],
];

const normalizePerilId = (perilId: string) =>
  perilId
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-');

export const getPerilIcon = (perilId: string): LucideIcon => {
  const normalized = normalizePerilId(perilId);
  return PERIL_ICONS.find(([pattern]) => pattern.test(normalized))?.[1] ?? Shield;
};
